import * as React from "react";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import MyAccountTab from "./MyAccountTab";
import UserManagementTab from "./UserManagementTab";
import LayerPermissionsTab from "./LayerPermissionsTab";
import RegistrationRequestsTab from "./RegistrationRequestsTab";
import AccessLogsTab from "./AccessLogsTab";
import { UserProfile } from "../../../global/types/user";

export interface TabPanelProps {
  index: number;
  value: number;
  user?: UserProfile | null;
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default function UserProfileTabs(props: { user: UserProfile | null }) {
  const [value, setValue] = React.useState(0);
  const { user } = props;
  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={handleChange}>
          <Tab label="Minha conta" {...a11yProps(0)} />
          <Tab label="Usuários" {...a11yProps(1)} />
          <Tab label="Camadas" {...a11yProps(2)} />
          <Tab label="Solicitações de cadastro" {...a11yProps(3)} />
          <Tab label="Acessos" {...a11yProps(4)} />
        </Tabs>
      </Box>
      <MyAccountTab user={user} value={value} index={0} />
      <UserManagementTab user={user} value={value} index={1} />
      <LayerPermissionsTab user={user} value={value} index={2} />
      <RegistrationRequestsTab user={user} value={value} index={3} />
      <AccessLogsTab user={user} value={value} index={4} />
    </Box>
  );
}
